export default __webpack_public_path__ + "static/media/oh.abae5a0a.mp3";